import {BehaviorSubject} from 'rxjs';
import {UserData} from "../models/userData.model";
 
export class CurrentUser {
    static currentUser$: BehaviorSubject<UserData> = new BehaviorSubject({} as UserData);
}